import { render, staticRenderFns } from "./operateFrame.vue?vue&type=template&id=fe93a7f2&scoped=true"
import script from "./operateFrame.vue?vue&type=script&lang=js"
export * from "./operateFrame.vue?vue&type=script&lang=js"
import style0 from "./operateFrame.vue?vue&type=style&index=0&id=fe93a7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe93a7f2",
  null
  
)

export default component.exports